"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./import-virtual-categories"), exports);
__exportStar(require("./export-virtual-categories"), exports);
__exportStar(require("./get-virtual-categories"), exports);
__exportStar(require("./get-virtual-category"), exports);
__exportStar(require("./create-virtual-category"), exports);
__exportStar(require("./update-virtual-category"), exports);
__exportStar(require("./delete-virtual-category"), exports);
__exportStar(require("./get-all-global-virtual-categories"), exports);
__exportStar(require("./get-global-virtual-category"), exports);
__exportStar(require("./create-global-virtual-category"), exports);
__exportStar(require("./update-global-virtual-category"), exports);
__exportStar(require("./delete-global-virtual-category"), exports);
__exportStar(require("./get-virtual-category-by-slug"), exports);
__exportStar(require("./get-global-virtual-category-by-slug"), exports);
